import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Teams, Sites, Athletes, Coaches, Videos } from '../../scenes';
import {
  SITES_ROUTE,
  TEAMS_ROUTE,
  COACHES_ROUTE,
  ATHLETES_ROUTE,
  VIDEOS_ROUTE
} from '../../utils/constants';

const Routes = ()=> {
  return (
    <Switch>
      <Route path={SITES_ROUTE} component={Sites}/>
      <Route path={TEAMS_ROUTE} component={Teams}/>
      <Route path={COACHES_ROUTE} component={Coaches}/>
      <Route path={ATHLETES_ROUTE} component={Athletes}/>
      <Route path={VIDEOS_ROUTE} component={Videos}/>
      {/* <Redirect exact from="/" to="sites" /> */}
    </Switch>
  )
}

export default Routes;